import { useState, useEffect, useMemo } from "react";
import { Alert, Empty, Spin } from "antd";
import { StyledSubscriptions } from "./styles";
import httpClient from "../../../api/httpClient";
import Pricing from "./Pricing";
import CurrentSubscription from "./CurrentSubscription";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentPlan,
  selectUserState,
} from "../../../store/user/selectors";
import { setPlans } from "../../../store/user/slice";
import { useSearchParams } from "react-router-dom";
import { checkIsOwner } from "./helper";

const Subscriptions = () => {
  const [searchParams] = useSearchParams();

  const tenant_id = searchParams.get("tenant_id");
  const [loading, setLoading] = useState(true);

  const currentPlan = useSelector(selectCurrentPlan);
  const { tenants } = useSelector(selectUserState);
  const dispatch = useDispatch();

  useEffect(() => {
    const getCurrentPlan = async () => {
      try {
        if (!loading) setLoading(true);
        if (checkIsOwner({ tenant_id, tenants })) {
          const { data } = await httpClient.get("paddle/subscriptions/current");

          dispatch(setPlans(data));
        }
      } catch (error) {
        console.log("🚀 ~ index.jsx:14 ~ Subscriptions ~ error:", error);
      } finally {
        setLoading(false);
      }
    };
    getCurrentPlan();
  }, []);

  const isOwner = useMemo(
    () => checkIsOwner({ tenant_id, tenants }),
    [tenant_id, tenants],
  );

  return (
    <StyledSubscriptions>
      {loading ? (
        <div className="h-100 w-100 flex-center loading">
          <Spin />
        </div>
      ) : !isOwner ? (
        <div className="not-owner flex-center">
          <Empty
            image={Empty.PRESENTED_IMAGE_DEFAULT}
            description={
              <Alert
                type="warning"
                showIcon
                title="Contact your organization owner or administrator to upgrade the subscription plan."
              />
            }
          />
        </div>
      ) : currentPlan ? (
        <CurrentSubscription currentPlan={currentPlan} />
      ) : (
        <Pricing />
      )}
    </StyledSubscriptions>
  );
};

export default Subscriptions;
